module.exports = __webpack_public_path__ + "img/w.de84e1bc.svg";